module.exports = {"product":{"startingPrice":"Ab","offer":"VERSCHENKEN","book":"Mehr"},"products":{"noResult":"Keine Aktivität entspricht Ihrer Suche."}}